import ControlsBlock from './component'

export default ControlsBlock
